<script lang="ts">
    import type {DirectoryInsight} from 'typings/portaro.be.types';
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import {encodeUri} from 'shared/utils/pipes';
    import {FileViewForm} from 'shared/constants/portaro.constants';
    import {exists} from 'shared/utils/custom-utils';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';

    const localize = getLocalization();
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    const model = pageContext.staticData.model;
    let directoryInsight: DirectoryInsight | undefined;
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => directoryInsight = data.directoryInsight);
    onDestroy(reactiveDataUnsubscribe);
</script>

{#if exists(directoryInsight) && (directoryInsight.sampleFiles.length > 0 || directoryInsight.withNonCoverFiles || directoryInsight.withSubdirectories)}
    <div class="side-column-panel">
        <section class="attachments-panel" aria-labelledby="attachments-panel-label">
            <KpGenericPanel hasBodyPadding="{false}">
                <svelte:fragment slot="heading">
                    <h2 id="attachments-panel-label" class="unset-style">
                        {localize(/* @kp-localization detail.PrilohyKeStazeni */ 'detail.PrilohyKeStazeni')}
                    </h2>
                </svelte:fragment>

                <ul class="attachments-list">
                    {#if directoryInsight.withNonCoverFiles || directoryInsight.withSubdirectories}
                        <li class="attachment-item">
                            <a href="/media-viewer?rootDirectory={model.record.directoryId}&origin={pipe(window.location.href, encodeUri())}">
                                {localize(/* @kp-localization file.ZobrazitPripojeneSoubory */ 'file.ZobrazitPripojeneSoubory')}
                            </a>
                        </li>
                    {/if}

                    {#each directoryInsight.sampleFiles as file(file.id)}
                        <li class="attachment-item">
                            <a href="/media-viewer?rootDirectory={model.record.directoryId}&origin={pipe(window.location.href, encodeUri())}#!?file={file.id}">
                                <div class="attachment-item-inner">
                                    {#if file.viewForms.includes(FileViewForm.THUMBNAIL)}
                                        <img class="connected-file-thumbnail"
                                             src="/files/{file.id}?width=80"
                                             alt="{file.name}"
                                             width="60"/>
                                    {/if}

                                    <span class="connected-file-label">
                                        {file.name}
                                    </span>
                                </div>
                            </a>
                        </li>
                    {/each}
                </ul>
            </KpGenericPanel>
        </section>
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .attachments-list {
        display: flex;
        flex-direction: column;

        .attachment-item {
            padding: @panel-heading-padding;
            border-bottom: 1px solid @table-border-color;

            &:last-child {
                border-bottom: none;
            }

            .attachment-item-inner {
                display: flex;
                align-items: center;
                gap: @padding-small-horizontal;
            }
        }
    }

    .connected-file-thumbnail {
        border: 1px solid @table-border-color;
        border-radius: @border-radius-small;
    }
</style>